import React, { useEffect, useState } from 'react';
import '../profile.css';
import './seller-support.css';
import api from '../../seller-apis/api';
import { Modal, ProgressBar } from 'react-bootstrap';
import Loader from '../common/Loader'
// image import file 
import fileImage from '../../assets/images/fileImage1.png' // file image
import fileVideo from "../../assets/images/fileVideo1.png" // video image
import convertFileToWebP from '../../utilities/convertFileToWebP'; // utilities
import axios from 'axios'; // axios
import { variables } from "../../Variables.json";  //jason
import { useAlert } from 'react-alert';
import servicesApi from '../../seller-apis/servicesApi';
import { GenUtilities } from '../../utilities/GenUtilities';

const typeList = [
    {
        label: "Lost",
        key: 'LOST'
    },
    {
        label: "Damaged",
        key: "DAMAGED"
    },
    {
        label: "Undelivered",
        key: "UNDELIVERED"
    },
    {
        label: "Others",
        key: "OTHERS"
    }
];

const initialForm = {
    req_type: '',
    desc: '',
    orderId: '',
    specification: ''
};

const RaiseDisputeForm = () => {

    const [form, setForm] = useState(initialForm);

    const [errors, setErrors] = useState({})

    const [modal, setModal] = useState(false);
    const [confirmationPopup, setConfirmationPopup] = useState(false);

    const [ticketNo, setTicketNo] = useState("");

    const [loader, setLoader] = useState(false);
    // image states
    const [urlListshow, seturlListshow] = useState(false);
    const [image1, setimage1] = useState("");
    const [image2, setimage2] = useState("");
    const [image3, setimage3] = useState("");
    const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"));
    const [vidurlListshow, setvidurlListshow] = useState(false);
    const [vidurlList, setvidurlList] = useState([]);
    const [finalImage, setFinalImage] = useState([])
    // Progress bar states
    const [imgprogress1, setimgprogress1] = useState(0);
    const [imgprogress2, setimgprogress2] = useState(0);
    const [imgprogress3, setimgprogress3] = useState(0);
    const [videoprogress, setvideoprogress] = useState(0);
    // Uploading states
    const [uploading1, setuploading1] = useState(false);
    const [uploading2, setuploading2] = useState(false);
    const [uploading3, setuploading3] = useState(false);
    const [uploadingVideo, setuploadingVideo] = useState(false);
    var s3Urls = [];
    var imagesName = [];
    var videosName = [];
    var vids3Urls = [];
    const alert = useAlert();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if (errors[name]) {
            setErrors((prevData) => ({
                ...prevData,
                [name]: undefined
            }))
        }
    }

    const handlePopup = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setConfirmationPopup(true)
        } else {
            setConfirmationPopup(false)
        }
    }

    const handleSubmit = async () => {
        setConfirmationPopup(false)
        setLoader(true);
        //media json
        const media = finalImage?.map((item) => {
            return {
                mediaType: item?.mediaType,
                url: item?.url
            }
        })
        try {
            const res = await api.Support.add({
                ...form,
                desc: form.desc.trim(),
                media: media,
                type: "disputes",
                claimStatus: "OPEN"
            });
            setTicketNo(res.data.data.ticket_no);
            setModal(true);
            handleReset();
            setLoader(false);
            setimage1("")
            setimage2("")
            setimage3("")
            setvidurlList([]);
        }
        catch (err) {
            alert.error(err?.response?.data?.message || "Some error occured")
        } finally {
            setLoader(false);
        }
    }

    const handleReset = () => {
        setForm({ ...initialForm });
        if (Object.keys(errors).length) {
            setErrors({})
        }
        setimage1("")
        setimage2("")
        setimage3("")
        setFinalImage([])
        setvidurlListshow(false);
        setvidurlList([]);
        // Reset progress bars
        setimgprogress1(0);
        setimgprogress2(0);
        setimgprogress3(0);
        setvideoprogress(0);
        // Reset uploading states
        setuploading1(false);
        setuploading2(false);
        setuploading3(false);
        setuploadingVideo(false);
    }

    const handleValidation = () => {
        const newErrors = {};

        if (!form.req_type) {
            newErrors.req_type = 'Type is required.';
        }

        if (form?.req_type === "OTHERS" && (form?.specification === "" || form?.specification === undefined || form?.specification === null || form?.specification?.trim() === "")) {
            newErrors.specification = 'Specification is mandatory.';
        }

        if (!form?.orderId || form?.orderId?.trim() === '' || form?.orderId === null || form?.orderId === undefined) {
            newErrors.orderId = 'Order ID is required.';
        }

        if (!form.desc || !form.desc.trim().length) {
            newErrors.desc = 'Description is required.';
        }

        if (form?.req_type === 'DAMAGED' && finalImage?.length === 0) {
            newErrors.media = 'At least one attachment is required for raising Damaged disputes.';
        }

        setErrors(newErrors);

        return !Object.keys(newErrors).length
    }

    //image
    //image upload function
    const handleFileChange = async (e, spcl) => {

        let comImg;
        let imageFinal;
        let registerImage;
        let isimgsSizevalid = true;
        let limit = e.target.files.length;
        const maxSize = 2 * 1024 * 1024;
        const allowedImageExtensions = [".png", ".jpg", ".jpeg"];

        seturlListshow(false);
        for (let i = 0; i < limit; i++) {
            const file = e.target.files[i];
            const FileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

            if (!allowedImageExtensions.includes(FileExtension)) {
                alert.info("Only PNG, JPG, and JPEG images are allowed.");
                e.target.value = "";
                continue;
            }

            if (file.size > maxSize) {
                alert?.info("A max size of 2 Mb image can be uploaded");
                e.target.value = "";
                continue;
            }
            let convertedImg = await convertFileToWebP(e.target.files[i]);
            const originalBlob = convertedImg;
            const strArray = convertedImg.name.split(".");
            const newName = strArray[0] + "-" + new Date().getTime() + "." + strArray[1];
            const renamedFile = new File([originalBlob], newName, { type: convertedImg.type });
            // var str = convertedImg.name;
            let extension = convertedImg.name.slice(
                convertedImg.name.lastIndexOf(".")
            );
            // comImg = str.replace(/[^\w]/g, "");
            comImg = newName.replace(/[^\w]/g, "");
            // imageFinal = "img_" + vendorId + "_" + comImg + extension;
            imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + newName)
            // registerImage = convertedImg;
            // registerImage = e.target.files[i];
            var data = {
                imageName: "seller/support/" + imageFinal,
            };
            imagesName.push(imageFinal);
            console.log("imageFinal", imageFinal);

            const fileToUpload = e.target.files[i];

            // Set uploading state to true
            switch (spcl) {
                case "image1":
                    setuploading1(true);
                    break;
                case "image2":
                    setuploading2(true);
                    break;
                case "image3":
                    setuploading3(true);
                    break;
            }

            const formdata = new FormData();
            formdata.append("file", renamedFile);
            servicesApi
                .getUploadUrl(data)
                .then((res) => {
                    console.log(res)
                    axios({
                        method: "post",
                        url: res.data,
                        data: formdata,
                        onUploadProgress: (data) => {
                            //Set the progress value to show the progress bar
                            const progressPercent = Math.round((100 * data.loaded) / data.total);
                            switch (spcl) {
                                case "image1":
                                    setimgprogress1(progressPercent);
                                    break;
                                case "image2":
                                    setimgprogress2(progressPercent);
                                    break;
                                case "image3":
                                    setimgprogress3(progressPercent);
                                    break;
                            }
                        },
                    })
                        .then((response) => {
                            console.log("response", response);
                            console.log("url === ", response?.data?.result.variants);
                            // Set image state AFTER successful upload
                            switch (spcl) {
                                case "image1":
                                    setimage1(fileToUpload);
                                    setimgprogress1(0);
                                    setuploading1(false);
                                    break;
                                case "image2":
                                    setimage2(fileToUpload);
                                    setimgprogress2(0);
                                    setuploading2(false);
                                    break;
                                case "image3":
                                    setimage3(fileToUpload);
                                    setimgprogress3(0);
                                    setuploading3(false);
                                    break;
                            }
                            setFinalImage((prev) => {
                                const updatedImages = [...prev];
                                const index = updatedImages.findIndex((img) => img.name === spcl);

                                const newImage = {
                                    mediaType: "image",
                                    url: response?.data?.result?.variants[0],
                                    name: spcl,
                                };

                                if (index !== -1) {
                                    updatedImages[index] = newImage; // Replace existing image
                                } else {
                                    updatedImages.push(newImage); // Add new image
                                }

                                return updatedImages;
                            });

                            // setFinalImage((prev) => [...prev, {
                            //     mediaType: "image",
                            //     url: response?.data?.result?.variants[0],
                            //     name: spcl
                            // }])
                            seturlListshow(true);
                            e.target.value = "";
                        })
                        .catch((error) => {
                            console.log(error);
                            alert.error("Failed to upload image. Please try again.");
                            // Reset progress and uploading state on error
                            switch (spcl) {
                                case "image1":
                                    setimgprogress1(0);
                                    setuploading1(false);
                                    break;
                                case "image2":
                                    setimgprogress2(0);
                                    setuploading2(false);
                                    break;
                                case "image3":
                                    setimgprogress3(0);
                                    setuploading3(false);
                                    break;
                            }
                            e.target.value = "";
                        });
                })
                .catch((err) => {
                    console.log(err);
                    alert.error("Failed to get upload URL. Please try again.");
                    // Reset uploading state on error
                    switch (spcl) {
                        case "image1":
                            setuploading1(false);
                            break;
                        case "image2":
                            setuploading2(false);
                            break;
                        case "image3":
                            setuploading3(false);
                            break;
                    }
                    e.target.value = "";
                });
            // api.product
            //     .saveProductImage(data)
            //     .then((res) => {
            //         axios({
            //             method: "put",
            //             url: res.data,
            //             data: registerImage,
            //         })
            //             .then((response) => {
            //                 setFinalImage((prev) => [...prev, {
            //                     mediaType: "image",
            //                     url: response?.config?.url.split("?")[0],
            //                     name: spcl
            //                 }])
            //                 seturlListshow(true);
            //             })
            //             .then((response) => {
            //                 seturlListshow(true);
            //             })
            //             .catch((error) => {
            //                 console.log(error);
            //             });
            //     })
            //     .catch((err) => console.log(err));
            s3Urls.push(imageFinal);
        }
    }

    //video
    //video upload function
    const showVideo = (event) => {
        setvidurlListshow(false);
        let comImg;
        let imageFinal;
        let registerImage;
        let videoSize = 0;
        const allowedVideoExtensions = [".mp4", ".mov"];
        const files = Array.from(event.target.files);

        if (event.target.files.length > 1 || vidurlList.length === 1) {
            alert.info("A max of 1 video can be uploaded");
            event.target.value = "";
            setvidurlListshow(true);
        }

        const file = files[0];
        const extension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

        if (!allowedVideoExtensions.includes(extension)) {
            alert.info("Only MP4 and MOV videos are allowed.");
            setvidurlListshow(true);
            event.target.value = "";
            return;
        }

        if (event.target.files.length > 0) {
            for (let i = 0; i < 1; i++) {
                videoSize = videoSize + event.target.files[i].size;
            }
            if (videoSize <= variables.limit.Newproductupload.video) {
                for (let i = 0; i < 1; i++) {
                    var str = event.target.files[i].name;
                    let extension = event.target.files[i].name.slice(
                        event.target.files[i].name.lastIndexOf(".")
                    );
                    comImg = str.replace(/[^\w]/g, "");
                    imageFinal = "vid_" + vendorId + "_" + comImg + extension;
                    registerImage = event.target.files[0];
                    var data = {
                        imageName: imageFinal,
                        type: "products",
                        bucket: "m",
                    };
                    imageFinal = GenUtilities.removeSpacesFromName("products/vid_" + vendorId + "_" + comImg + extension);
                    videosName.push(imageFinal);
                    setuploadingVideo(true);
                    api.product
                        .saveProductImage(data)
                        .then((res) => {
                            axios({
                                method: "put",
                                url: res.data,
                                data: registerImage,
                                onUploadProgress: (data) => {
                                    //Set the progress value to show the progress bar
                                    setvideoprogress(Math.round((100 * data.loaded) / data.total));
                                },
                            })
                                .then((response) => {
                                    console.log("res", response);
                                    setvideoprogress(0); // Reset progress after successful upload
                                    setuploadingVideo(false); // Reset uploading state
                                    setFinalImage((prev) => [...prev, {
                                        mediaType: "video",
                                        url: response?.config?.url.split("?")[0],
                                    }])
                                    setvidurlList(videosName);
                                    setvidurlListshow(true);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    setvideoprogress(0);
                                    setuploadingVideo(false);
                                    alert.error("Failed to upload video. Please try again.");
                                    event.target.value = "";
                                });
                        })
                        .catch((err) => {
                            console.log(err);
                            setuploadingVideo(false);
                            alert.error("Failed to upload video. Please try again.");
                            event.target.value = "";
                        });
                    vids3Urls.push(imageFinal);
                    event.target.value = "";
                }
            } else {
                alert.info("A max size of 15 Mb video can be uploaded");
                event.target.value = "";
            }
        }
    }

    //image remove function
    const handleRemoveAttachment = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        console.log("imagesName", imagesName);

        imagesName.splice(id, 1);
        switch (id) {
            case "image1":
                setimage1("");
                setimgprogress1(0);
                setuploading1(false);
                break;
            case "image2":
                setimage2("");
                setimgprogress2(0);
                setuploading2(false);
                break;
            case "image3":
                setimage3("");
                setimgprogress3(0);
                setuploading3(false);
                break;
        }
        setFinalImage((prev) => prev.filter((item) => item.name !== id));
        // let eleLoader = document.getElementById(ele);
        // eleLoader.setAttribute("class", "spinner-border text-info")
    };

    //video delete function 
    const deletevideo = (e, index, id) => {
        e.preventDefault();
        e.stopPropagation();
        setvidurlListshow(false);
        setvidurlList([]);
        videosName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Vid-upload");
        setFinalImage((prev) => prev.filter((item) => item.mediaType !== id));
        setvidurlList(videosName);
        setvideoprogress(0); // Reset video progress
        setuploadingVideo(false); // Reset uploading state

        eleLoader.setAttribute("class", "spinner-border text-info");

        setTimeout(() => {
            eleLoader.removeAttribute("class");

            setvidurlListshow(true);
        }, 1000);
    }

    return (
        <>

            <form onSubmit={handlePopup} onReset={handleReset} className='seller-support-form'>

                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Type *
                            </label>
                        </div>
                        <div className='col-md-2 col-sm-12'>
                            <select
                                value={form.req_type}
                                name="req_type"
                                onChange={handleChange}
                                className='profile-input'
                                placeholder='Select Type'

                            >
                                <option value='' hidden>Select your option...</option>
                                {
                                    typeList.map((type) =>
                                        <option key={type.key} value={type.key}>
                                            {type.label}
                                        </option>
                                    )
                                }
                            </select>
                        </div>
                        <div className='offset-2 col-10'>
                            {errors.req_type && <span className="error">{errors.req_type}</span>}
                        </div>
                    </div>

                </div>

                {form?.req_type === "OTHERS" && <>
                    <div className='seller-support-form__field'>
                        <div className='row align-items-start flex-direction-column'>
                            <div className='col-md-2 col-sm-12'>
                                <label className='fs-12'>
                                    Specification *
                                </label>
                            </div>
                            <div className='col-md-2 col-sm-12'>
                                <input type='text'
                                    className='profile-input'
                                    onChange={handleChange}
                                    name='specification'
                                    style={{ width: '200px' }}
                                    placeholder='Please specify'
                                    value={form.specification}
                                />
                            </div>
                            <div className='offset-2 col-10'>
                                {errors?.specification && <span className="error">{errors?.specification}</span>}
                            </div>
                        </div>
                    </div>
                </>}

                {/* SL-953 (3-10-25)*/}
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Order ID *
                            </label>
                        </div>
                        <div className='col-md-2 col-sm-12'>
                            <input type='text'
                                className='profile-input'
                                onChange={handleChange}
                                name='orderId'
                                value={form.orderId}
                            />
                        </div>
                        <div className='offset-2 col-10'>
                            {errors?.orderId && <span className="error">{errors?.orderId}</span>}
                        </div>
                    </div>

                </div>
                {/* SL-953 (3-10-25) ends*/}
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Description *
                            </label>
                        </div>
                        <div className='col-md-6 col-sm-12'>
                            <textarea
                                value={form.desc}
                                name="desc"
                                onChange={handleChange}
                                className='profile-input'
                                placeholder='Enter description here...'
                                rows={4}
                            />
                        </div>
                        <div className='offset-2 col-10'>
                            {errors.desc && <span className="error">{errors.desc}</span>}
                        </div>
                    </div>
                </div>
                <div className='seller-support-form__field'>
                    <div className='row align-items-start flex-direction-column'>
                        <div className='col-md-2 col-sm-12'>
                            <label className='fs-12'>
                                Attachments {form?.req_type === "DAMAGED" ? "*" : ""}
                            </label>
                        </div>
                        <div className='col-md-6 col-sm-12'>
                            <div className='seller-support-form-attachments'>
                                <div>
                                    {imgprogress1 > 0 && <ProgressBar now={imgprogress1} label={`${imgprogress1}%`} className="mt-2" style={{ width: "auto" }} />}
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image1" name='image1' className='file-input' onChange={(e) => handleFileChange(e, 'image1')} disabled={uploading1} />
                                        <label htmlFor="image1" className='upload-label' style={{ opacity: uploading1 ? 0.6 : 1, cursor: uploading1 ? 'not-allowed' : 'pointer' }}>
                                            {(urlListshow === true &&
                                                image1 !== undefined &&
                                                image1 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image1')}
                                                        disabled={uploading1}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            <img
                                                src={urlListshow === true &&
                                                    image1 !== undefined &&
                                                    image1 !== "" ? URL.createObjectURL(image1) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image1 && !uploading1 && <span>Upload Image</span>}
                                            {uploading1 && <span>Uploading...</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ml-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {imgprogress2 > 0 && <ProgressBar now={imgprogress2} label={`${imgprogress2}%`} className="mt-2" style={{ width: "auto" }} />}
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image2" name='image2' className='file-input' onChange={(e) => handleFileChange(e, 'image2')} disabled={uploading2} />
                                        <label htmlFor="image2" className='upload-label' style={{ opacity: uploading2 ? 0.6 : 1, cursor: uploading2 ? 'not-allowed' : 'pointer' }}>
                                            {(urlListshow === true &&
                                                image2 !== undefined &&
                                                image2 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image2')}
                                                        disabled={uploading2}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            <img
                                                src={urlListshow === true &&
                                                    image2 !== undefined &&
                                                    image2 !== "" ? URL.createObjectURL(image2) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image2 && !uploading2 && <span>Upload Image</span>}
                                            {uploading2 && <span>Uploading...</span>}
                                        </label>
                                    </div>
                                    <div className="add_pro_form_video mt-4 ml-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {imgprogress3 > 0 && <ProgressBar now={imgprogress3} label={`${imgprogress3}%`} className="mt-2" style={{ width: "auto" }} />}
                                    <div className='attachment-box'>
                                        <input type='file' accept=".jpg, .jpeg, .png" id="image3" name='image3' className='file-input' onClick={(e) => e.target.value = null} onChange={(e) => handleFileChange(e, 'image3')} disabled={uploading3} />
                                        <label htmlFor="image3" className='upload-label' style={{ opacity: uploading3 ? 0.6 : 1, cursor: uploading3 ? 'not-allowed' : 'pointer' }}>
                                            {(urlListshow === true &&
                                                image3 !== undefined &&
                                                image3 !== "") && (
                                                    <button
                                                        className="close-button"
                                                        onClick={(e) => handleRemoveAttachment(e, 'image3')}
                                                        disabled={uploading3}
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            <img
                                                src={urlListshow === true &&
                                                    image3 !== undefined &&
                                                    image3 !== "" ? URL.createObjectURL(image3) : fileImage}
                                                alt="Uploaded"
                                                className="uploaded-preview"
                                            />
                                            {!image3 && !uploading3 && <span>Upload Image</span>}
                                            {uploading3 && <span>Uploading...</span>}
                                        </label>
                                    </div>

                                    <div className="add_pro_form_video mt-4 ml-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 2 Mb</span>
                                        </div>
                                    </div>
                                </div>
                                <div className=''>
                                    {videoprogress > 0 && <ProgressBar now={videoprogress} label={`${videoprogress}%`} className="mt-2" style={{ width: "auto" }} />}
                                    <div className='attachment-box'>
                                        <input type='file' accept=".mp4, .mov" id="video1" name='video1' className='file-input' onClick={(e) => e.target.value = null} onChange={(event) => showVideo(event)} disabled={uploadingVideo} />
                                        <label htmlFor="video1" className='upload-label' style={{ opacity: uploadingVideo ? 0.6 : 1, cursor: uploadingVideo ? 'not-allowed' : 'pointer' }}>
                                            {vidurlListshow === true ? (
                                                vidurlList.map((item, index) => {
                                                    return (
                                                        <>
                                                            <button
                                                                className="close-button"
                                                                onClick={(e) => deletevideo(e, index, "video")}
                                                                disabled={uploadingVideo}
                                                            >
                                                                ×
                                                            </button>
                                                            <video
                                                                src={"https://media.toolsvilla.com/" +
                                                                    item}
                                                                // autoPlay
                                                                controls
                                                                className="uploaded-preview"
                                                            />
                                                        </>

                                                    )
                                                }
                                                )) : ""}
                                            {vidurlListshow === false && !uploadingVideo && <img src={fileVideo} alt="Upload Video" />}
                                            {vidurlListshow === false && !uploadingVideo && <span>Upload Video</span>}
                                            {uploadingVideo && <span>Uploading Video...</span>}
                                        </label>
                                    </div>

                                    <div className="add_pro_form_video mt-4 ml-4">
                                        <div className="video-instruction">
                                            <span>1. Size Max 15 Mb</span>
                                            <br></br>
                                            <span>2. Format - MP4</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {errors?.media && <span className="error">{errors?.media}</span>}
                    </div>
                </div>

                <div className='seller-support-form__btns'>
                    <div className='row'>
                        <div className='d-flex col'>

                            <button type='submit' className='seller-support-form__btn seller-support-form__btn--submit mr-3'>
                                SUBMIT
                            </button>
                            <button type='reset' className='seller-support-form__btn seller-support-form__btn--cancel'>
                                CANCEL
                            </button>
                        </div>
                    </div>
                </div>

            </form>
            <Modal show={confirmationPopup} centered>
                <Modal.Body className='seller-support-confirmation-popup'>
                    <div className='seller-support-confirmation-popup__heading'>
                        Do you want to submit the ticket ?
                    </div>
                    <div className='seller-support-confirmation-popup__buttons'>
                        <button className='seller-support-confirmation-popup__buttons seller-support-confirmation-popup__button--yes' onClick={handleSubmit}>
                            Yes
                        </button>
                        <button className='seller-support-confirmation-popup__buttons seller-support-confirmation-popup__button--no' onClick={() => setConfirmationPopup(false)}>
                            No
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modal} size="lg" centered>
                <Modal.Body>
                    <div className='px-2 pb-2'>
                        <div className='text-end'>
                            <img src="/common/cross.png" alt="Close" height={17} className='cursor-pointer' onClick={() => setModal(false)} />
                        </div>

                        <div className='text-center'>
                            <div className='pt-3 pb-2 seller-support-ticket-popup__heading'>
                                Ticket id
                                <span className='pt-3 pb-2 seller-support-ticket-popup__heading--primary'>
                                    {ticketNo}
                                </span> raised successfully.
                            </div>
                            <div className='pb-5 seller-support-ticket-popup__sub-heading mx-auto'>
                                Toolsvilla team will get back to you soon.
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Loader show={loader} />
        </>
    )

}

export default RaiseDisputeForm;